/** Мок-данные признания выручки для вёрстки, пока нет API */

export const PROJECTS = [
  {
    id: 1,
    name: "ОД_514-1_Б_ЗД_МЖК_МЖКОIUУчасток6_Цесинстрой_2025",
    organization: "AQMOL-project ТОО",
    counterparty: "BI Group ТОО",
    article: "Выручка по проектированию",
  },
  {
    id: 2,
    name: "ОД_320-2_А_ЖК_Riverside_Очередь2_BIGroup_2025",
    organization: "AQMOL-project ТОО",
    counterparty: "BI Group ТОО",
    article: "Выручка по проектированию",
  },
  {
    id: 3,
    name: "ОД_118-1_В_БЦ_AlmaTower_Блок1_Базис_2025",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "Базис-А ТОО",
    article: "Выручка по авторскому надзору",
  },
  {
    id: 4,
    name: "ОД_402-3_Б_ШК_Школа1200_Косшы_2026",
    organization: "AQMOL-project ТОО",
    counterparty: "КазСтройСервис ТОО",
    article: "Выручка по проектированию",
  },
  {
    id: 5,
    name: "ОД_227-1_А_ЖК_GreenPark_Участок3_Sensata_2025",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "Sensata Group ТОО",
    article: "Выручка по BIM-моделированию",
  },
  {
    id: 6,
    name: "ОД_615-2_В_ТРЦ_Mega_Реконструкция_MegaCenter_2026",
    organization: "AQMOL-project ТОО",
    counterparty: "Mega Center ТОО",
    article: "Выручка по проектированию",
  },
];

export const CONTRACTS = [
  { id: 1, projectId: 1, name: "№ AIF /ДП-РП/ Fm - Nst /114477 от 25.09.2025г.", amount: 60000000 },
  { id: 2, projectId: 1, name: "№ AIF /АН/ Fm - Nst /114478 от 25.09.2025г.", amount: 12000000 },
  { id: 3, projectId: 2, name: "№ RVS /ДП-РП/ 2025-031 от 14.03.2025г.", amount: 85000000 },
  { id: 4, projectId: 3, name: "№ ALT /АН/ 2025-112 от 02.06.2025г.", amount: 42000000 },
  { id: 5, projectId: 4, name: "№ SCH /ДП-РП/ 2026-004 от 20.01.2026г.", amount: 38500000 },
  { id: 6, projectId: 5, name: "№ GRP /BIM/ 2025-077 от 11.08.2025г.", amount: 54000000 },
  { id: 7, projectId: 6, name: "№ MGC /ДП-РП/ 2026-019 от 05.03.2026г.", amount: 72000000 },
];

export const ARTICLES = [
  "Выручка по проектированию",
  "Выручка по авторскому надзору",
  "Выручка по BIM-моделированию",
  "Выручка по экспертизе",
];

export const ORGANIZATIONS = [...new Set(PROJECTS.map((project) => project.organization))];
export const COUNTERPARTIES = [...new Set(PROJECTS.map((project) => project.counterparty))].sort(
  (a, b) => a.localeCompare(b, "ru")
);

export const PROJECT_BY_ID = Object.fromEntries(PROJECTS.map((project) => [project.id, project]));
export const CONTRACT_BY_ID = Object.fromEntries(CONTRACTS.map((contract) => [contract.id, contract]));

/** Периоды признания по проектам; проект 6 намеренно не настроен */
export const INITIAL_PROJECT_SETTINGS = [
  { id: 1, projectId: 1, startDate: "01.01.2026", endDate: "31.12.2026" },
  { id: 2, projectId: 2, startDate: "01.01.2026", endDate: "30.09.2026" },
  { id: 3, projectId: 3, startDate: "01.02.2026", endDate: "31.12.2026" },
  { id: 4, projectId: 4, startDate: "01.03.2026", endDate: "28.02.2027" },
  { id: 5, projectId: 5, startDate: "01.01.2026", endDate: "31.10.2026" },
];

const MONTH_ENDS_2026 = [
  "31.01.2026",
  "28.02.2026",
  "31.03.2026",
  "30.04.2026",
  "31.05.2026",
  "30.06.2026",
  "31.07.2026",
  "31.08.2026",
];

/** Готовность по месяцам: договор → первый месяц (индекс) и проценты на конец каждого месяца */
const READINESS_PLAN = [
  { contractId: 1, fromMonth: 0, readiness: [3, 6, 10, 14, 18, 22, 25] },
  { contractId: 3, fromMonth: 0, readiness: [10, 18, 26, 35, 44, 52, 60, 68] },
  { contractId: 4, fromMonth: 1, readiness: [8, 15, 22, 30, 38, 46, 55] },
  { contractId: 5, fromMonth: 2, readiness: [5, 10, 18, 25, 32, 40] },
  { contractId: 6, fromMonth: 0, readiness: [12, 20, 30, 38, 47, 55, 63, 72] },
];

const buildRecognitions = () => {
  const result = [];
  READINESS_PLAN.forEach(({ contractId, fromMonth, readiness }) => {
    const contract = CONTRACT_BY_ID[contractId];
    const project = PROJECT_BY_ID[contract.projectId];
    let previous = 0;
    readiness.forEach((percent, index) => {
      const cumulative = Math.round((contract.amount * percent) / 100);
      result.push({
        date: MONTH_ENDS_2026[fromMonth + index],
        projectId: project.id,
        organization: project.organization,
        counterparty: project.counterparty,
        contractId,
        article: project.article,
        contractAmount: contract.amount,
        readiness: percent,
        cumulative,
        previous,
        current: cumulative - previous,
      });
      previous = cumulative;
    });
  });
  return result.map((item, index) => ({
    ...item,
    id: index + 1,
    document: `ПВ-${String(index + 101).padStart(6, "0")}`,
  }));
};

export const INITIAL_RECOGNITIONS = buildRecognitions();

/** Справочники в формате, который ожидает общая страница признания */
export const REVENUE_DATA = {
  projects: PROJECTS,
  contracts: CONTRACTS,
  articles: ARTICLES,
  organizations: ORGANIZATIONS,
  counterparties: COUNTERPARTIES,
  projectById: PROJECT_BY_ID,
  contractById: CONTRACT_BY_ID,
};
